module.exports = __webpack_public_path__ + "static/polarpumpen-footerBanner-035fe47a82815f40b757ac4329dbef5a.jpg";